import GuestForm from "./components/GuestForm/GuestForm";

export default function GuestDetails() {
  return (
    <div className="flex w-full flex-col">
      <GuestForm />
    </div>
  );
}
